import { useState, useEffect } from 'react';
import Router from 'next/router';
var useLoading = function () {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(false), dataLoading = _b[0], setDataLoading = _b[1];
    var handleRouteChangeStart = function () {
        setLoading(true);
    };
    var handleRouteChangeComplete = function () {
        setLoading(false);
    };
    var handleRouteChangeError = function () {
        setLoading(false);
    };
    useEffect(function () {
        Router.events.on('routeChangeStart', handleRouteChangeStart);
        Router.events.on('routeChangeComplete', handleRouteChangeComplete);
        Router.events.on('routeChangeError', handleRouteChangeError);
        return function () {
            Router.events.off('routeChangeStart', handleRouteChangeStart);
            Router.events.off('routeChangeComplete', handleRouteChangeComplete);
            Router.events.off('routeChangeError', handleRouteChangeError);
        };
    }, []);
    return { loading: loading, dataLoading: dataLoading, setDataLoading: setDataLoading };
};
export default useLoading;
//# sourceMappingURL=useLoading.js.map